// TODO: nextTierLimit should come from api, not hardcoded
export const UsageLimitToI18nKey = {
  snippets: {
    name: 'snippets',
    nextTierLimit: 5000
  },
  documents: {
    name: 'documents',
    nextTierLimit: 5000
  },
  'cms-landing-pages': {
    name: 'landingPages',
    nextTierLimit: 10000
  },
  'cms-site-pages': {
    name: 'websitePages',
    nextTierLimit: 50
  },
  templates: {
    name: 'templates',
    nextTierLimit: 5000
  }
};